module.exports = __webpack_public_path__ + "static/media/threshold-exceeded.3a2c7929.svg";